var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable max-len */
import { hideApplicationLoader, } from 'common/ApplicationLoader';
import { getFacilityManagementService } from 'services/coporateAndFacilitiesService/FacilityManagementService/facilitymanagement.service';
import { showError } from 'store/commonReducer/common.action';
export var GET_FACILITY_MANAGEMENT_LIST = 'GET_FACILITY_MANAGEMENT_LIST';
export var GET_FACILITY_MANAGEMENT_LIST_SUCCESS = 'GET_FACILITY_MANAGEMENT_LIST_SUCCESS';
export var GET_FACILITY_MANAGEMENT_LIST_FAIL = 'GET_FACILITY_MANAGEMENT_LIST_FAIL';
export var UPDATE_FACILITY_MANAGEMENT_LIST_PAGE_NUMBER = 'UPDATE_FACILITY_MANAGEMENT_LIST_PAGE_NUMBER';
export var RESET_FACILITY_MANAGEMENT_LIST = 'RESET_FACILITY_MANAGEMENT_LIST';
export var GET_FACILITY_MANAGEMENT_SEARCH_LIST_SUCCESS = 'GET_FACILITY_MANAGEMENT_SEARCH_LIST_SUCCESS';
export var GET_FACILITY_DATA = 'GET_FACILITY_DATA';
export var SET_TOTAL_RESIDENTS = 'SET_TOTAL_RESIDENTS';
export var RESET_TOTAL_RESIDENTS = 'RESET_TOTAL_RESIDENTS';
export var SET_FACILITY_TYPE_FILTER = 'SET_FACILITY_TYPE_FILTER';
export var SHOW_FACILITY_BREADCRUMB = 'SHOW_FACILITY_BREADCRUMB';
export var HIDE_FACILITY_BREADCRUMB = 'HIDE_FACILITY_BREADCRUMB';
/**
 * @functions showFacilityBreadcrumb
 * @description action creator to show the facility breadcumbs
 * @returns void
 */
export var showFacilityBreadcrumb = function () { return ({
    type: SHOW_FACILITY_BREADCRUMB
}); };
/**
 * @functions showFacilityBreadcrumb
 * @description action creator to hide the facility breadcumbs
 * @returns void
 */
export var hideFacilityBreadcrumb = function () { return ({
    type: HIDE_FACILITY_BREADCRUMB
}); };
/**
 * @functions getFacilityList
 * @description action creator to fetch the facility lists
 * @returns void
 */
export var getFacilityList = function (searchQuery, corpId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var lastEvaluatedKey, payload, response, filteredData, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch({ type: GET_FACILITY_MANAGEMENT_LIST });
                    lastEvaluatedKey = (_b = (_a = getState().cIRangeMilestones) === null || _a === void 0 ? void 0 : _a.completed) === null || _b === void 0 ? void 0 : _b.lastEvaluatedKey;
                    payload = {
                        corporate_id: corpId,
                    };
                    if (lastEvaluatedKey) {
                        payload.last_evaluated_key = lastEvaluatedKey;
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getFacilityManagementService(payload)];
                case 2:
                    response = _c.sent();
                    dispatch({
                        type: 'SET_TOTAL_RESIDENTS',
                        payload: response.totalResidents,
                    });
                    filteredData = response.data;
                    if (searchQuery) {
                        filteredData = filteredData.filter(function (data) { var _a; return (_a = data === null || data === void 0 ? void 0 : data.facilityName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.toLowerCase()); });
                    }
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, {
                            data: filteredData,
                            lastEvaluatedKey: response === null || response === void 0 ? void 0 : response.lastEvaluatedKey,
                        }];
                case 3:
                    error_1 = _c.sent();
                    dispatch(showError(error_1));
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * @function getFacilityListSuccess
 * @description action creator to store facility table data
 * @param tableData
 */
export var getFacilityListSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data, lastEvaluatedKey = tableData.lastEvaluatedKey, searchLastEvaluatedKey = tableData.searchLastEvaluatedKey;
    dispatch({
        type: GET_FACILITY_MANAGEMENT_LIST_SUCCESS,
        payload: {
            data: data,
            lastEvaluatedKey: lastEvaluatedKey,
            searchLastEvaluatedKey: searchLastEvaluatedKey,
        },
    });
}; };
/**
 * @function getFacilitySearchListSuccess
 * @description action creator to search facility list
 * @param tableData
 */
export var getFacilitySearchListSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data, lastEvaluatedKey = tableData.lastEvaluatedKey;
    dispatch({
        type: GET_FACILITY_MANAGEMENT_SEARCH_LIST_SUCCESS,
        payload: {
            data: data,
            searchLastEvaluatedKey: lastEvaluatedKey,
        },
    });
}; };
/**
 * @function getFacilityListFail
 * @description action creator to fetch error on api get fail
 * @param error
 */
export var getFacilityListFail = function (error) { return function (dispatch) {
    dispatch(showError(error));
    dispatch({
        type: GET_FACILITY_MANAGEMENT_LIST_FAIL,
    });
}; };
/**
 * @function updateFacilityPageNumber
 * @description action creator to update the page number of facility management table
 * @param {string | number} value
 */
export var updateFacilityPageNumber = function (value) { return function (dispatch) {
    dispatch({
        type: UPDATE_FACILITY_MANAGEMENT_LIST_PAGE_NUMBER,
        payload: value,
    });
}; };
/**
 * @function resetFacilityManagementList
 * @description action creator to reset facility table
 */
export var resetFacilityManagementList = function () { return function (dispatch) {
    dispatch({
        type: RESET_FACILITY_MANAGEMENT_LIST,
    });
}; };
/**
 * @description method to flter data on FE, search by name
 * @function searchFacilityByName
 * @param {any[]} data
 * @param {string} searchQuery
 * @returns {any[]}
 */
export var searchFacilityByName = function (data, searchQuery) {
    if (data === void 0) { data = []; }
    if (searchQuery === void 0) { searchQuery = ''; }
    return data.filter(function (facility) {
        var query = searchQuery.toLowerCase();
        var corpName = facility.facilityName.toLowerCase() || '';
        return corpName.includes(query);
    });
};
export var getFacilityData = function (data) { return function (dispatch) {
    dispatch({
        type: GET_FACILITY_DATA,
        payload: data,
    });
}; };
